module.exports = __webpack_public_path__ + "media/images/weo-tv-white-square-fc4fc42f1b417614576e09a373fa016f.png";